export default __webpack_public_path__ + "static/1-c032ad32ea18bc683a60838c695aeb30.png";